













import Vue from 'vue'
import { IDevice } from '@/types/model'
import mixins from 'vue-typed-mixins'
import { slaveDeviceDialogMixin } from '@/mixins'
import easyapi from '@/easyapi'

export default mixins(slaveDeviceDialogMixin).extend({
  computed: {
    device (): IDevice | null { return this.dialog.device }
  },
  methods: {
    apply () {
      if (!this.device) { return }
      easyapi.rebootDevice(this.device).then((ok) => {
        if (ok) {this.closeThisDialog()}
      })
    }
  },
})
